import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Header } from './landingPage/Header';
import { Embed as EmbedSection } from './landingPage/sections/Embed';
import { Tabs as TabsSection } from './landingPage/sections/Tabs';
import { Links as LinksSection } from './landingPage/sections/Links';
import { Footer } from './landingPage/Footer';

const Root = styled.div`
  min-width: calc(${globalTheme.spacing.lg} * 68);
`;

export const LandingPage: FC = () => (
  <Root>
    <Header />
    <EmbedSection />
    <TabsSection />
    <LinksSection />
    <Footer />
  </Root>
);
